import { LocationResidentsList } from "app/features/locations/templates/LocationResidentsList";

export default function LocationPage() {
  return <LocationResidentsList />;
}
